<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-copyright element-without-heading" id="copyright-2">
<div class="text" id="copyright-2-text">
<p class="first first-in-chapter first-full-width copyright-content">Without limiting the rights under copyright(s) reserved below, no part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior permission of the publisher and the copyright owner.</p>
<p class="subsq copyright-content">This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events or locales is entirely coincidental.</p>
<p class="subsq copyright-content">The scanning, uploading, and distributing of this book via the internet or via any other means without the permission of the publisher and copyright owner is illegal and punishable by law. Please purchase only authorized copies, and do not participate in or encourage piracy of copyrighted materials. Your support of the author’s rights is appreciated.</p>
<p class="subsq copyright-content">Copyright © 2017, 2019 by S.L. Menear. All rights reserved.</p>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">Book and cover design by eBook Prep</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">www.ebookprep.com</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">July, 2019</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">ISBN: 978-1-64457-085-2</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content"><b><i>ePublishing Works!</i></b></p>
<p class="alignment-block-content alignment-block-content-left copyright-content">644 Shrewsbury Commons Ave</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Ste 249</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Shrewsbury PA 17361</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">United States of America</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">www.epublishingworks.com</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Phone: 866-846-5123</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5a584025